import React from 'react';
import {
  EndpointByFunction,
  HttpEndpointByFunction,
  isHttpEndpoint,
} from '@hud/portal-dtos/src/lib/webapp-function.dto';
import { HudIcon } from '../../Icons/HudIcons';
import { NodeTitleWithIconContainer } from './NodeTitleWithIconContainer';

export function EndpointNodeBody({
  methodsDisplay,
  endpoint,
}: {
  methodsDisplay: string;
  endpoint: EndpointByFunction | HttpEndpointByFunction; // remove EndpointByFunction after all clients update from v1.1.32 in vscode & v1.0.1 in JB (28.11.2024)
}) {
  const serviceName = isHttpEndpoint(endpoint) ? endpoint.service.name : undefined;

  return (
    <NodeTitleWithIconContainer
      title={methodsDisplay}
      icon={<HudIcon icon="webviewMenu.endpoint" />}
      path={endpoint.path}
      service={serviceName}
    />
  );
}
